

const getMediaUrl = url => {
  if (url.indexOf('http') == 0) return url;
  if (url.indexOf('data:image') == 0) return url;
  return window.mediaDomainUrl + '/' + url;
}

export { getMediaUrl };